




























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';
import VirtualMachineNetworkNats from '@/components/virtual-machine-edit/VirtualMachineNetworkNats.vue';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';

@Component({
  props: ['virtualMachine'],
  components: {
    VirtualMachineNetworkNats,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineNetwork extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  accordions: any = {};
  networkCards: any = {};
  isAddingNewNetworkCardActive = false;
  privateNetworksForSelect: any = [];
  privateNetworksForEditSelect: any = [];
  privateNetworksAvailable: any = [];
  publicIpAddressesForSelect = {};
  networkCardsData: any = [];
  name = '';
  ip_address = '';
  private_network_id = '';
  public_ip_address_id: any = '';
  isEditModeActive: any = {};
  isRemoveNetworkCardModalShown = false;
  deleteNetworkCardId = '';
  validation: boolean = false;
  validationOnEditMode: any = [];
  regexCheckIp = true;
  isIpCollision = false;
  itemId = 0;
  isLoading = false;
  showRestartRequiredInfo = false;
  isRestartRequired = false;

  @Watch('$store.state.networkCards.nics', { immediate: true, deep: true })
  onNicsChange(data: any) {
    if (this.virtualMachineId) {
      this.networkCardsData = this.$store.getters['networkCards/getVirtualMachineNics'](this.virtualMachineId);
      this.afterNicsUpdate();
    }
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.itemId = parseInt(this.$route.params.itemId, 10);
    this.getNewNetworkCard();
  }
  getNewNetworkCard() {
    virtualMachineDetailsService.getNetworkCard(this.workspaceId, this.regionId).then((data: any) => {
      this.privateNetworksForSelect = data.private_networks.filter((ip: any) => ip.state === 'idle');
      this.privateNetworksAvailable = data.private_networks.filter((ip: any) => ip.state === 'idle');
      this.publicIpAddressesForSelect = data.public_ip_addresses.filter((ip: any) => ip.state === 'idle');
      this.getNics();
    });
  }
  cancelNewNetworkCard() {
    this.isAddingNewNetworkCardActive = false;
    this.validation = false;
  }
  createNewNetworkCard() {
    this.validation = true;
    this.regexCheckIp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
      this.ip_address
    );
    this.isIpCollision = false;
    if (!this.regexCheckIp || !this.name || this.name.length < 4 || !this.ip_address || !this.private_network_id) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .createNetworkCard(this.workspaceId, this.regionId, {
        name: this.name,
        ip_address: this.ip_address,
        private_network_id: this.private_network_id,
        public_ip_address_id: this.public_ip_address_id,
        virtual_machine_id: this.virtualMachineId,
      })
      .then(() => {
        this.isLoading = false;
        this.getNics();
        this.isAddingNewNetworkCardActive = false;
        this.validation = false;
      })
      .catch(err => {
        this.isLoading = false;
        if (err.status === 422) {
          this.isIpCollision = !!err.data.error.ip_address.length;
        }
      });
  }
  updateNetCard(networkCardId: any) {
    this.validationOnEditMode[networkCardId] = true;
    this.validationOnEditMode = { ...this.validationOnEditMode };
    this.regexCheckIp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
      this.ip_address
    );
    this.isIpCollision = false;
    if (!this.regexCheckIp || !this.name || this.name.length < 4 || !this.ip_address || !this.private_network_id) {
      return;
    }
    if (this.isRestartRequired) {
      this.showRestartRequiredInfo = true;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .updateNetworkCard(this.workspaceId, this.regionId, networkCardId, {
        name: this.name,
        ip_address: this.ip_address,
        private_network_id: this.private_network_id,
        public_ip_address_id: this.public_ip_address_id,
      })
      .then(() => {
        this.isLoading = false;
        this.isEditModeActive = {};
        this.getNewNetworkCard();
      })
      .catch(err => {
        this.isLoading = false;
        if (err.status === 422) {
          this.isIpCollision = !!err.data.error.ip_address.length;
        }
      });
  }
  getNics() {
    storeService.getNics(true).then(() => {
      this.networkCardsData = this.$store.getters['networkCards/getVirtualMachineNics'](this.virtualMachineId);
      this.afterNicsUpdate();
    });
  }
  afterNicsUpdate() {
    const privNetworks = this.networkCardsData.map((item: any) => {
      return item.private_network.id;
    });
    this.privateNetworksForSelect = this.privateNetworksAvailable.filter((item: any) => {
      return privNetworks.indexOf(item.id) === -1;
    });
    this.toggleAccordion(`mapowania-nat-'${this.itemId}'`);
  }

  deleteNetworkCard(networkCardId: any) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .deleteNetworkCard(this.workspaceId, this.regionId, networkCardId)
      .then(() => {
        this.getNics();
        this.onCloseRemoveNetworkCardModal();
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  showAddNetworkCardForm() {
    this.name = '';
    this.private_network_id = '';
    this.ip_address = '';
    this.public_ip_address_id = null;
    this.isAddingNewNetworkCardActive = !this.isAddingNewNetworkCardActive;
  }
  setAddressValue(privateNetworkId: any) {
    if (!privateNetworkId) {
      return;
    }
    const network = this.privateNetworksForSelect.filter((item: any) => item.id === privateNetworkId)[0];
    this.ip_address = network.suggested_private_address;
  }
  onCloseRemoveNetworkCardModal() {
    this.isRemoveNetworkCardModalShown = false;
  }
  openRemoveNetworkCardModal(networkCardId: any) {
    this.deleteNetworkCardId = networkCardId;
    this.isRemoveNetworkCardModalShown = true;
  }
  toggleAccordion(name: string) {
    this.accordions[name] = !this.accordions[name];
    this.accordions = { ...this.accordions };
  }
  getAccordionState(name: string) {
    return { active: !!this.accordions[name] };
  }
  editNetworkCardMode(networkCard: any) {
    this.validationOnEditMode = {};
    this.isIpCollision = false;
    this.name = networkCard.name;
    this.ip_address = networkCard.ip_address;
    this.private_network_id = networkCard.private_network.id;
    this.public_ip_address_id = networkCard.public_ip_address.inherited ? null : networkCard.public_ip_address.id;
    this.isEditModeActive = {};
    this.isEditModeActive[networkCard.id] = true;
    this.isEditModeActive = { ...this.isEditModeActive };
    const privNetworks = this.networkCardsData.map((item: any) => {
      return item.private_network.id;
    });
    this.privateNetworksForEditSelect = this.privateNetworksAvailable.filter((item: any) => {
      return privNetworks.indexOf(item.id) === -1 || this.private_network_id === item.id;
    });
  }
  getNetworkCardState(name: string) {
    return { editMode: !!this.networkCards[name] };
  }
  validationOnEdition(networkCardId: any) {
    return this.validationOnEditMode[networkCardId] && this.isEditModeActive[networkCardId];
  }
}
